
import { defineComponent } from 'vue';
import Overlay from '@/components/Overlay.vue';
import { OrderItem } from '@/modules/dashboardStock/types';

export default defineComponent({
  name: 'DashboardDailyBilling',

  components: {
    Overlay,
  },

  props: {
    Orders: {
      type: Array as () => OrderItem[],
      default: () => [],
    },

    loading: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      items: [] as OrderItem[],
      maxOrders: 20,
    };
  },

  watch: {
    Orders() {
      this.items = [...this.Orders]
        .sort(
          (a, b) =>
            new Date(a.DATA_INICIAL).getTime() -
            new Date(b.DATA_INICIAL).getTime()
        )
        .slice(0, this.maxOrders)
        .map((item) => ({
          ...item,
          DATA_INICIAL: item.DATA_INICIAL,
          DATA_FORMATADA: new Date(item.DATA_INICIAL).toLocaleDateString(
            'pt-BR'
          ),
        }));
    },
  },

  setup() {
    const verifyIndex = (index: number): any => {
      if (index < 5) return { 'high-delay': true };
    };

    return { verifyIndex };
  },
});
